export const statusOptions = [
  { label: 'Pendente', value: 'pending' },
  { label: 'Ativo', value: 'enabled' },
  { label: 'Inativo', value: 'disabled' },
];
